/**
 * @pageName Inventory
 * @slotType dashboard plugin
 */
export type InventoryBannerParams = {};

/**
 * @pageName Inventory
 * @slotType dashboard menu plugin
 */
export type InventoryItemsBulkMoreActionsMenuParams = BulkActionMenuSlotProps;

/** @internal */
export type BulkActionMenuSlotProps = {
  // 	Total number of selected items.
  total: number;
  // When `allSelected` is `true`, an array of IDs of items that were manually deselected.
  uncheckedIds: string[];
  // Whether the **Select All** checkbox was selected.
  allSelected: boolean;
  // Array of IDs of selected items.
  selectedIds: string[];
};

/**
 * @pageName Inventory
 * @slotType dashboard menu plugin
 */
export type InventoryMainMoreActionsMenuParams = {};

/**
 * @pageName Inventory
 * @slotType dashboard menu plugin
 */
export type InventoryItemMoreActionsMenuParams = SingleItemMenuSlotProps;

/** @internal */
export type SingleItemMenuSlotProps = {
  // When the item is the default product version, the value is `${productId}`. When the item is a variant, the value is `${productId}_${variantId}`.
  selectedId: string[];
};
